import React, { useEffect, useState } from 'react';
import { useCommonStats, useAccountStats } from '../hooks/useStats';
import { toast } from 'react-toastify';
import { getContract } from '../helper/contractHelper';
import stakeAbi from '../json/tokenstake.json';
import sLogo from '../images/s-logo.png';
import { ethers } from 'ethers';
import { useEthersSigner } from '../hooks/useEthersSigner';
import { CHAIN_INFO, DEFAULT_CHAIN } from '../helper/constant';
import { useAccount } from 'wagmi';
import { formatPrice, getWeb3 } from '../helper/functions';



export default function Stake() {

    const daysTab = {
        links: [
            // {
            //     id: 1,
            //     className: "StakeTablinks",
            //     content: "30 Days",
            //     apy: "1",
            //     timestamp: "30"
            // },
            // {
            //     id: 2,
            //     className: "StakeTablinks",
            //     content: "90 Days",
            //     apy: "3",
            //     timestamp: "90"
            // },
            {
                id: 1,
                className: "StakeTablinks",
                content: "180 Days",
                apy: "3",
                timestamp: "180"
            },
            {
                id: 2,
                className: "StakeTablinks",
                content: "365 Days",
                apy: "7",
                timestamp: "365"

            }
        ],
        activeLink: null
    };

    const { chainId, address } = useAccount();
    const library = useEthersSigner()
    const [dayId, setDayId] = useState(1);
    const [updater, setUpdater] = useState(1);
    const stats = useCommonStats(updater);
    const accStats = useAccountStats(updater);
    const [apy, setApy] = useState(daysTab.links[0].apy);
    const [amount, setAmount] = useState(0);
    const [error_msg, setError_msg] = useState('');
    const [ereturn, setEreturn] = useState(0);
    const timeElapsed = Date.now();
    const today = new Date(timeElapsed);
    const [endtime, setEndtime] = useState(new Date(parseInt(timeElapsed) + parseInt(daysTab.links[0].timestamp * 86400 * 1000)));
    const [loading, setLoading] = useState(false);

    const handleChangeDay = (id) => {
        setDayId(id);
        setApy(daysTab.links[id - 1].apy)
        setEndtime(new Date(parseInt(timeElapsed) + parseInt(daysTab.links[id - 1].timestamp * 86400 * 1000)))
    }

    const handleChangeAmount = (e) => {
        setAmount(e.target.value);
        

        if (isNaN(e.target.value)) {
            setError_msg('Please enter valid amount');
            
        }

        else if (parseFloat(e.target.value) === 0 || e.target.value === '') {
            setError_msg('Amount must be greater than zero');
            
        }
        else {
            setError_msg('');
            
        }
        return;
    }

    const handleStake = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            if (amount > 0 && !isNaN(e.target.value)) {
                if (address) {
                    if (chainId === DEFAULT_CHAIN) {
                        if (parseFloat(accStats.balance) >= parseFloat(amount)) {
                            if (typeof dayId !== 'undefined' || dayId !== 0) {
                                let lockupDuration = daysTab.links[dayId - 1].timestamp;
                                let tokenStakingAddress = CHAIN_INFO[DEFAULT_CHAIN].stake_address;
                                let stakeContract = getContract(stakeAbi, tokenStakingAddress, library);
                                let stakeAmount = ethers.utils.parseEther(amount.toString())

                                let tx = await stakeContract.deposit(lockupDuration, { 'from': address , value : stakeAmount });
                                const resolveAfter3Sec = new Promise(resolve => setTimeout(resolve, 5000));
                                toast.promise(
                                    resolveAfter3Sec,
                                    {
                                        pending: 'Waiting for confirmation.',
                                    }
                                )

                                var interval = setInterval(async function () {
                                    let web3 = getWeb3();
                                    var response = await web3.eth.getTransactionReceipt(tx.hash);
                                    if (response != null) {
                                        clearInterval(interval)
                                        if (response.status === true) {
                                            toast.success('Success! Your transaction has completed.');
                                            setUpdater(Math.random());
                                            setLoading(false);
                                        }
                                        else if (response.status === false) {
                                            toast.error('error ! Your last transaction is failed.');
                                            setUpdater(Math.random());
                                            setLoading(false);
                                        }
                                        else {
                                            toast.error('error ! something went wrong.');
                                            setUpdater(Math.random());
                                            setLoading(false);
                                        }
                                    }
                                }, 5000);
                            }
                            else {
                                toast.error('Please select days !');
                                setLoading(false);
                            }
                        }
                        else {
                            toast.error('you don\'t have enough balance !');
                            setLoading(false);
                        }

                    }
                    else {
                        toast.error('Please select Smart Chain Network !');
                        setLoading(false);
                    }
                }
                else {
                    toast.error('Please Connect Wallet!');
                    setLoading(false);
                }
            }
            else {
                toast.error('Please Enter Valid Amount !');
                setLoading(false);
            }
        }
        catch (err) {
            toast.error(err.reason);
            setLoading(false);
        }
    }


    useEffect(() => {
        setEreturn(parseFloat(amount) + parseFloat((amount * daysTab.links[dayId - 1].apy / 100) / 365) * daysTab.links[dayId - 1].timestamp);
        // eslint-disable-next-line
    }, [amount, dayId])


    return (
        <div className="staking-overflow py-4 py-sm-5">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
                            <li className="nav-item" role="presentation">
                                <a href="#sec" className="nav-link fs-21 active" >Stake BST
                                </a>
                            </li>
                        </ul>
                        <div className="tab-content rounded-8 mt-4 mt-sm-5" id="pills-tabContent">
                            {/* <!--STAKING-OVERFLOW--> */}
                            <div className="tab-pane fade show active" id="pills-staking-overflow" role="tabpanel"
                                aria-labelledby="pills-staking-overflow-tab">
                                <div className="row gx-4 gy-3 gy-sm-0 gx-sm-5 mb-4 mb-sm-5 ">
                                    <div className="col-sm-6">
                                        <div className="top-content d-flex flex-column gap-3 text-white justify-content-center align-items-center">
                                            <p>Total Tokens Staked</p>
                                            <div className="fs-28 fw-bold">{formatPrice(parseFloat(stats.totalStake) - parseFloat(stats.totalWithdrawal))} BST</div>
                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        <div className="top-content info d-flex flex-column gap-3 text-white justify-content-center align-items-center">
                                            <p>Average Staking Days</p>
                                            <div className="fs-28 fw-bold">120 Days</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row mb-100">
                                    <div className="col-12">
                                        <div className="fs-28 mb-sm-5 mb-4">Staking Submission</div>
                                        <div className="d-flex staking-days flex-wrap flex-lg-nowrap">
                                            {daysTab.links.map(link => {
                                                return (
                                                    <div key={link.id} onClick={(e) => { handleChangeDay(link.id) }} className={`${link.id === dayId ? " active" : ""} align-items-center w-100 d-flex flex-column item justify-content-center rounded-8 position-relative overflow-hidden`}>
                                                        <div className="fs-21">{link.content}</div>
                                                        <p>{link.apy}% APY</p>
                                                    </div>

                                                )
                                            })
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12">
                                        <div className="align-items-center d-flex flex-wrap flex-sm-nowrap w-100 gap-2 gap-sm-4">
                                            <div className="fs-21 flex-shrink-0">
                                                Amount to be staked:
                                            </div>
                                            <div className="input-staked d-flex w-100 p-2">
                                                <input type="text" className="form-control" value={amount} onChange={(e) => { handleChangeAmount(e) }} placeholder="Enter amount" />
                                                <img src={sLogo} className="img-fluid" alt="s-logo" style={{ "width": "51px" }} />
                                            </div>
                                        </div> 
                                        <h5 className='fs-21 mt-2 fw-normal mb-4 mb-sm-5 ml-254 text-danger mt-3'><small>{error_msg}</small></h5>

                                        <div className="fs-21 mt-2 fw-normal mb-4 mb-sm-5 ml-254">Your Balance: {formatPrice(accStats.balance)} BST</div>

                                        <div className="fs-21 mt-2 fw-bold mb-3 mb-sm-4 ml-254 ml-0">Staking Summary</div>

                                        <div className="ml-254 ml-0">
                                            <div className="table-grid">
                                                <div>
                                                    <div>Duration</div>
                                                    <div>:</div>
                                                    <div>{daysTab.links[dayId - 1].content}</div>
                                                </div>
                                                <div>
                                                    <div>APY</div>
                                                    <div>:</div>
                                                    <div>{apy}%</div>
                                                </div>
                                                <div>
                                                    <div>Stake Amount</div>
                                                    <div>:</div>
                                                    <div>{formatPrice(amount)} BST</div>
                                                </div>
                                                <div>
                                                    <div>Estimated Return</div>
                                                    <div>:</div>
                                                    <div>{formatPrice(ereturn)} BST</div>
                                                </div>
                                                <div>
                                                    <div>Start Date</div>
                                                    <div>:</div>
                                                    <div>{today.toUTCString()}</div>
                                                </div>
                                                <div>
                                                    <div>End Date</div>
                                                    <div>:</div>
                                                    <div>{endtime.toUTCString()}</div>
                                                </div>
                                            </div>

                                            <button disabled={loading} className="button h-48 w-100 my-4 my-sm-5" onClick={(e) => !loading && handleStake(e)}>
                                                {loading ? 'LOADING...' : 'STAKE NOW'}
                                            </button>

                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}
